import { render, staticRenderFns } from "./ToggleButtonGroup2.vue?vue&type=template&id=6753b212&scoped=true"
import script from "./ToggleButtonGroup2.vue?vue&type=script&lang=js"
export * from "./ToggleButtonGroup2.vue?vue&type=script&lang=js"
import style0 from "./ToggleButtonGroup2.vue?vue&type=style&index=0&id=6753b212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6753b212",
  null
  
)

export default component.exports